<template>
  <!-- <Admin v-if="isNeedToLogin"></Admin>
  <div v-else-if="isLoggedIn"></div>
  <Layout v-else-if="isInfoReady"></Layout> -->
  <el-config-provider :locale="zhCn">
    <Login v-if="isNeedToLogin"></Login>
    <div v-else-if="isLoggedIn"></div>
    <Layout v-else-if="isInfoReady"></Layout>
  </el-config-provider>
</template>
<script setup>
import { onMounted, computed } from 'vue'
import Layout from './pages/Layout/Layout.vue'
import Login from './pages/Login.vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import { useUserInfoStore } from '@/store/userInfo'

const userInfoStore = useUserInfoStore()

const isNeedToLogin = computed(() => userInfoStore.isNeedToLogin)
const isLoggedIn = computed(() => userInfoStore.isLoggedIn)
const isInfoReady = computed(() => userInfoStore.isInfoReady)

onMounted(() => {
  userInfoStore.init()
})
</script>

<style lang="scss" scoped></style>
